import { Link } from '@inertiajs/react';
import { Button } from '../../design-system/components';
export default function Error404() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-secondary px-4">
      <div className="text-center">
        <p className="text-6xl font-bold text-fg">404</p>
        <h1 className="mt-4 text-2xl font-semibold text-fg">Page Not Found</h1>
        <p className="mt-2 text-fg-secondary">
          Sorry, we couldn&apos;t find the page you&apos;re looking for. It may have been moved or
          deleted.
        </p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Button variant="outline" onClick={() => window.history.back()}>
            Go Back
          </Button>
          <Link href="/">
            <Button>Go Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
